import { Center, Container, Loader } from "@mantine/core";
import { useCalendarContext } from "../../../contexts/CalendarContext";
import ErrorCard from "../../../shared/components/blocks/ErrorCard";
import CalendarTable from "./components/CalendarTable";
import CalendarTableFilters from "./components/CalendarTableFilters";
import { COLORS } from "../../../constants/colorConstants";
import { useLocalAuthorityContext } from "../../../contexts/LocalAuthorityContext";
import CalendarListHeader from "./components/CalendarListHeader";
import { useNavigationHistory } from "../../../shared/contexts/NavigationHistoryContext";
import { useEffect } from "react";

export default function CalendarList() {
  const { updateLatestHistoryItemWithOptions, getCurrentHistoryOptions, useAutoScrollManagement } =
    useNavigationHistory();
  const { tableFetch } = useCalendarContext();
  const { dropdownFetch } = useLocalAuthorityContext();

  useEffect(() => {
    tableFetch.enableTableFetch();
    dropdownFetch.enableDropdownFetch();
  }, []);

  const TableContent = () => {
    if (tableFetch?.isLoading || dropdownFetch?.isLoading) {
      return (
        <Center>
          <Loader color={COLORS.DARK_WINE} size="xl" type="bars" />
        </Center>
      );
    }

    if (tableFetch?.error) {
      return <ErrorCard error={tableFetch.error} />;
    }

    if (dropdownFetch?.error) {
      return <ErrorCard error={dropdownFetch.error} />;
    }

    return <CalendarTable />;
  };

  return (
    <Container fluid>
      <CalendarListHeader />
      <CalendarTableFilters />
      <TableContent />
    </Container>
  );
}
